import React, { forwardRef } from 'react';

import { useTranslate } from '@/hooks/useTranslate';

import CloseIcon from './icon/close';
import { TransCodingIcon } from './icon/transcoding';

export interface UploadTranscodingProps {
  url: string;
  slotNode?: (url: string) => React.ReactNode;
  onCancel: () => void;
}

const UploadTranscoding = forwardRef<HTMLDivElement, UploadTranscodingProps>(
  (props, ref): React.ReactNode => {
    const { slotNode, url, onCancel } = props;
    const { t } = useTranslate();
    return (
      <div ref={ref} className={`wrapper-upload-step w-full h-full`}>
        {slotNode ? (
          slotNode(url)
        ) : (
          <div className="w-full h-full flex flex-col items-center justify-center">
            <TransCodingIcon />
            <div className="pt-[10px] pb-[18px] flex items-center gap-[8px]">
              <span className="text-[14px] font-[500] leading-[20px] font-sans">
                {t('transcoding')}...
              </span>
            </div>

            <div
              className="cursor-pointer"
              onClick={(e) => {
                e && e.stopPropagation();
                onCancel && onCancel();
              }}
            >
              <CloseIcon />
            </div>
          </div>
        )}
      </div>
    );
  },
);

export default UploadTranscoding;
